import moment from 'moment';
import db from '../../db';
import { throwErrorMessage } from '../../lib/error_helper';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { downloadFile } from '../../utils';
import { analyseRisquesIsLoading } from '../analyseRisques/analyseRisquesActions';
import { SET_SPP_FOUND } from '../analyseRisques/analyseRisquesConstants';

export function setSPPFoundAction(sppFound) {
    return {
        type: SET_SPP_FOUND,
        sppFound
    }
}

async function readFile(event) {
    const blob = event.target.result;
    // Store the binary data in indexedDB:
    await db.transaction("rw?", db.Files, async () => {
        await db.Files.put({
            name: "test",
            image: blob
        });
    }).catch((e) => {
        console.error("Erreur lors de l'upload du fichier")
        throw e;
    });
}

export function storeFile(evt) {
    var file = evt.target.files[0];
    var reader = new FileReader();
    reader.addEventListener('load', readFile);
    reader.readAsText(file);
}

export function clearSPPSearch() {
    return (dispatch) => {
        dispatch(setSPPFoundAction(null));
    }
}

export function downloadSPP(spp, user) {
    return (dispatch) => {
        dispatch(analyseRisquesIsLoading(true));
        const headers = new Headers({ 'Content-Type': 'application/json' });

        fetchWithTimeout("/api/v1/spp/download_spp/", {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                userId: user.id,
                sppId: spp.id,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(result => {
                if (result.length <= 0 || !result[0].datas) {
                    console.error("Le plan de prévention simplifié est introuvable")
                    dispatch(analyseRisquesIsLoading(false));
                    return;
                }

                let file = result[0];

                var dataURI = "data:application/msword;base64," + file.datas;
                downloadFile(dataURI, file.datas_fname ? file.datas_fname : "PPS");
                dispatch(analyseRisquesIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : simplifiedPreventPlanActions - downloadSPP", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors du téléchargement du plan de prévention simplifié !",
                }))
                dispatch(analyseRisquesIsLoading(false));
            });
    }
}


export function searchSPP(customerId, date) {
    return (dispatch) => {

        dispatch(clearSPPSearch());
        let dateAsMoment = moment(date);
        dispatch(analyseRisquesIsLoading(true));

        const headers = new Headers({ 'Content-Type': 'application/json' });

        const body = JSON.stringify({
            searchInput: '',
            isSpp: true,
            companyId: "",
            customer: customerId.toString(),
            workOrder: '',
            affair: '',
            status: "",
        })

        fetchWithTimeout('/api/v1/analyseRisques/search/', {
            method: 'POST',
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(analyseRisquesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((sppList) => {
                let filteredSpp = sppList.filter(spp => spp.customer_id &&
                    spp.customer_id[0] === customerId &&
                    moment(spp.start_date).isSameOrBefore(dateAsMoment, 'day') &&
                    moment(spp.expected_end_date).isSameOrAfter(dateAsMoment, 'day')
                )

                if (filteredSpp.length <= 0)
                    return

                let sppFound = filteredSpp[0];
                dispatch(setSPPFoundAction(sppFound));
            })
            .catch((err) => {
                console.error("Erreur : simplifiedPreventPlanActions - searchSPP", err)

                let message = "Une erreur est survenue lors de la récupération des PPS !";

                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: message,
                }));
                dispatch(analyseRisquesIsLoading(false));
            });
    }
}
